// extracted by mini-css-extract-plugin
module.exports = {"copied":"CopyToClipboardWithNotification_copied__1yMlo","wrapper":"CopyToClipboardWithNotification_wrapper__2sbaY"};